export default {
  'pages.entryRegistration.title': 'Entry Registration',
  'pages.entryRegistration.breadcrumb.person': 'Person Management',
  'pages.entryRegistration.breadcrumb.entryRegistration': 'Entry Registration',
  
  // Filters
  'pages.entryRegistration.filter.registrationType': 'Registration Type',
  'pages.entryRegistration.filter.status': 'Status',
  
  // Registration Types
  'pages.entryRegistration.type.guest': 'Guest Registration',
  'pages.entryRegistration.type.moveout': 'Move-out Registration',
  'pages.entryRegistration.type.decoration': 'Decoration Filing',
  
  // Status
  'pages.entryRegistration.status.all': 'All',
  'pages.entryRegistration.status.registered': 'Registered',
  'pages.entryRegistration.status.in_progress': 'In Progress',
  'pages.entryRegistration.status.completed': 'Completed',
};
